// const baseSize = 75;
// function setRem() {
//   const scale = document.documentElement.clientWidth / 750;
//   let fontSize =
//     baseSize * Math.min(scale, 2) > 12 ? baseSize * Math.min(scale, 2) : 12;
//   document.documentElement.style.fontSize = fontSize + "px";
// }
// setRem();
// window.onresize = function () {
//   setRem();
// };

// (function (win, doc) {
//   change();
//   function change() {
//     console.log("---------doc.documentElement.clientWidth",doc.documentElement.clientWidth)
//     if (doc.documentElement.clientWidth * 75 / 375 > 22) {
//       doc.documentElement.style.fontSize = '22px'
//     } else {
//       doc.documentElement.style.fontSize = doc.documentElement.clientWidth * 75 / 375 + 'px';
//     }
//   }

//   win.addEventListener('resize', change, false);
//   win.addEventListener('orientationchange', change, false);
// })(window, document);
// var docEl = document.documentElement,
// resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
// recalc = function () {
//   if (20 * (docEl.clientWidth / 375) > 22) {
//     docEl.style.fontSize = '22px';
//   } else {
//     docEl.style.fontSize = 75 * (docEl.clientWidth / 375) + 'px';
//   }
// };
// window.addEventListener(resizeEvt, recalc, false);
// document.addEventListener('DOMContentLoaded', recalc, false);

fnResize();
window.onresize = function () {
  fnResize();
};
function fnResize() {
  var deviceWidth = document.documentElement.clientWidth || window.innerWidth;
  if (deviceWidth >= 1024) {
    deviceWidth = 2048;
  }
  if (deviceWidth < 1024 && deviceWidth > 750) {
    deviceWidth = 2 * deviceWidth;
  }
  if (deviceWidth <= 750 && deviceWidth > 320) {
    deviceWidth = 750;
  }
  if (deviceWidth <= 320) {
    deviceWidth = 320;
  }
  console.log("-----deviceWidth / 7.5", deviceWidth / 7.5);
  document.documentElement.style.fontSize = deviceWidth / 7.5 + "px";
}
